import type { BrandSpecial, UserSegmentIds } from '@iheartjane/data-access';
import { brandSpecialHasSegments } from '@iheartjane/menu';

/* eslint-disable-next-line no-restricted-imports */
import type { PendingCartProduct } from '@jane/shared/models';

import type {
  AlgoliaUserSegmentIds,
  ProductWithBrandSpecialSegments,
} from './shouldShowSpecial';

export const brandSpecialOrProductHasSegments = ({
  brandSpecial,
  cartProduct,
  product,
}: {
  brandSpecial?: Pick<BrandSpecial, 'special_type' | 'rules'>;
  cartProduct?: Pick<PendingCartProduct, 'brand_special_has_segment_rules'>;
  product?: Pick<
    ProductWithBrandSpecialSegments,
    | 'applicable_brand_specials_excluded_user_segments'
    | 'applicable_brand_specials_included_user_segments'
  >;
}) => {
  if (brandSpecial) {
    return brandSpecialHasSegments({
      rules: brandSpecial.rules,
      specialType: brandSpecial.special_type,
    });
  }

  if (
    product &&
    'applicable_brand_specials_included_user_segments' in product &&
    'applicable_brand_specials_excluded_user_segments' in product
  ) {
    const includedSegments =
      product.applicable_brand_specials_included_user_segments as AlgoliaUserSegmentIds;
    const excludedSegments =
      product.applicable_brand_specials_excluded_user_segments as AlgoliaUserSegmentIds;
    const noIncludedSegments =
      !includedSegments ||
      includedSegments === -1 ||
      !(includedSegments as UserSegmentIds).length;
    const noExcludedSegments =
      !excludedSegments ||
      excludedSegments === -1 ||
      !(excludedSegments as UserSegmentIds).length;
    const needsSegments = !noIncludedSegments || !noExcludedSegments;

    return needsSegments;
  }

  if (cartProduct) {
    return Boolean(cartProduct.brand_special_has_segment_rules);
  }

  return false;
};
